export default "__VITE_ASSET__5795b2c3__"